// Mock data for EPG India Landing Page - Bilingual (English/Hindi)

export const mockDataIndia = {
  en: {
    header: {
      logoText: "EPG India",
      buttons: [
        { text: "Book a Call", type: "outline" },
        { text: "Privacy", type: "outline" }
      ]
    },
    hero: {
      badge: "We have been investing in precious metals since 2015",
      headline: "Invest in Gold and Silver on Your Terms!",
      subheading: "Welcome to Electrum Prosperity Group India!",
      benefits: [
        "Authorized distributor of precious metals in compliance with regulations",
        "Secure storage and dedicated logistics services",
        "Gold bonus for confirmed referrals",
        "Simple platform to manage directly from your phone"
      ],
      stats: [
        { value: "+$80", label: "in Gold", sublabel: "for each referral" },
        { value: "$500", label: "Cash", sublabel: "rewards" },
        { value: "$820", label: "Total", sublabel: "potential" },
        { value: "Weekly", label: "Payments", sublabel: "" }
      ],
      ctas: [
        { text: "Book a Call", type: "primary" },
        { text: "Join Now!", type: "secondary" }
      ],
      email: "electrumpg@gmail.com",
      videoUrl: process.env.REACT_APP_VIDEO_URL || "https://www.7kmetals.com/stusimonsen/share/xyt25"
    },
    features: [
      {
        title: "Recommend 4 friends = $820 USD",
        description: "Earn $320 USD in pure gold (4 x $80) + $500 in cash rewards. More than the cost of Legacy membership."
      },
      {
        title: "Are you ready to get started?",
        description: "If you're ready to start, we provide full training. No prior experience required."
      },
      {
        title: "Learn More!",
        description: ""
      }
    ],
    contactForm: {
      title: "Contact Us",
      fields: [
        { name: "name", placeholder: "Full Name", type: "text" },
        { name: "email", placeholder: "Email", type: "email" },
        { name: "phone", placeholder: "Phone", type: "tel" }
      ],
      submitText: "Send & Notify Me",
      privacyText: "I agree to be contacted. See",
      privacyLink: "Privacy Policy"
    },
    footer: {
      copyright: "© 2025 EPG India",
      email: "electrumpg@gmail.com",
      cta: "Ready to start your journey with EPG?",
      ctaButton: "Join Now!"
    },
    languageToggle: {
      label: "Language",
      english: "English",
      hindi: "हिंदी"
    }
  },
  hi: {
    header: {
      logoText: "EPG India",
      buttons: [
        { text: "कॉल बुक करें", type: "outline" },
        { text: "गोपनीयता", type: "outline" }
      ]
    },
    hero: {
      badge: "हम 2015 से बहुमूल्य धातुओं में निवेश कर रहे हैं",
      headline: "अपनी शर्तों पर सोने और चांदी में निवेश करें!",
      subheading: "इलेक्ट्रम प्रॉस्पेरिटी ग्रुप इंडिया में आपका स्वागत है!",
      benefits: [
        "विनियमों के अनुरूप बहुमूल्य धातुओं के अधिकृत वितरक",
        "सुरक्षित भंडारण और समर्पित लॉजिस्टिक सेवाएं",
        "पुष्टि किए गए रेफरल के लिए सोने में बोनस",
        "फोन से सीधे प्रबंधित करने के लिए सरल प्लेटफॉर्म"
      ],
      stats: [
        { value: "+$80", label: "सोने में", sublabel: "प्रत्येक रेफरल के लिए" },
        { value: "$500", label: "नकद", sublabel: "पुरस्कार" },
        { value: "$820", label: "कुल", sublabel: "संभावित" },
        { value: "साप्ताहिक", label: "भुगतान", sublabel: "" }
      ],
      ctas: [
        { text: "कॉल बुक करें", type: "primary" },
        { text: "अभी शामिल हों!", type: "secondary" }
      ],
      email: "electrumpg@gmail.com",
      videoUrl: process.env.REACT_APP_VIDEO_URL || "https://www.7kmetals.com/stusimonsen/share/xyt25"
    },
    features: [
      {
        title: "4 दोस्तों की सिफारिश = 820 USD",
        description: "शुद्ध सोने में $320 USD (4 x $80) + नकद पुरस्कारों में $500 कमाएं। लिगेसी सदस्यता की लागत से अधिक।"
      },
      {
        title: "क्या आप शुरू करने के लिए तैयार हैं?",
        description: "यदि आप शुरू करने के लिए तैयार हैं, तो हम पूर्ण प्रशिक्षण प्रदान करते हैं। कोई पूर्व अनुभव आवश्यक नहीं है।"
      },
      {
        title: "और जानें!",
        description: ""
      }
    ],
    contactForm: {
      title: "संपर्क करें",
      fields: [
        { name: "name", placeholder: "पूरा नाम", type: "text" },
        { name: "email", placeholder: "ईमेल", type: "email" },
        { name: "phone", placeholder: "फोन", type: "tel" }
      ],
      submitText: "भेजें और मुझे सूचित करें",
      privacyText: "मैं संपर्क करने के लिए सहमत हूं। देखें",
      privacyLink: "गोपनीयता नीति"
    },
    footer: {
      copyright: "© 2025 EPG India",
      email: "electrumpg@gmail.com",
      cta: "EPG के साथ अपनी यात्रा शुरू करने के लिए तैयार हैं?",
      ctaButton: "अभी शामिल हों!"
    },
    languageToggle: {
      label: "भाषा",
      english: "English",
      hindi: "हिंदी"
    }
  }
};
